import api from '@/api'

const state = {
  recursoClases: []
}

const getters = {
  recursoClases: (state) => {
    return state.recursoClases
  }
}

const mutations = {
  SET_CLASES_RECURSO(state, recursoClases) {
    state.recursoClases = recursoClases
  }
}

const actions = {
  async fetchClaseRecurso({ commit }) {
    try {
      const response = await api.recursoClase.getClasesRecurso()
      commit('SET_CLASES_RECURSO', response.data)

    } catch (err) {
      console.error(err)
      throw err
    }
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
